import { render, staticRenderFns } from "./ProductImgList.vue?vue&type=template&id=c777fc54&scoped=true"
import script from "./ProductImgList.vue?vue&type=script&lang=js"
export * from "./ProductImgList.vue?vue&type=script&lang=js"
import style0 from "./ProductImgList.vue?vue&type=style&index=0&id=c777fc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c777fc54",
  null
  
)

export default component.exports